<template>
  <div>
    <v-dialog
      :value="value"
      style="z-index: 1000"
      persistent
      max-width="780px"
      width="48vw"
    >
      <v-card>
        <v-card-title class="headline body" primary-title>
          これまで設定した内容がすべて破棄されますがよろしいですか？
        </v-card-title>
        <v-card-actions>
          <v-spacer />
          <AppButtonCancel @click.native="$emit('clickNg')">
            いいえ
          </AppButtonCancel>
          <AppButtonOk @click="$emit('clickOk')" color="primary">
            はい
          </AppButtonOk>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: 'AppEditConfirmModal',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style scoped>
.body {
  white-space: pre-line;
  word-wrap: break-word;
}
</style>
